import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PoolerJobsService {
  private readonly hideAllJobsLoadingSubject = new BehaviorSubject(false);

  readonly hideAllJobsLoading$: Observable<boolean> =
    this.hideAllJobsLoadingSubject.asObservable();

  constructor(private ngZone: NgZone) {}

  runHideAllJobs(): void {
    if (this.hideAllJobsLoadingSubject.value) {
      return;
    }
    this.hideAllJobsLoadingSubject.next(true);
    Meteor.call('hideAllJobs', (error: Meteor.Error) => {
      this.ngZone.run(() => {
        this.hideAllJobsLoadingSubject.next(false);
        if (error?.error) {
          throw new Meteor.Error(error.error);
        }
      });
    });
  }
}
